export default __webpack_public_path__ + "static/media/projects.1484c59b.svg";